import { useState } from 'react';
import MemberDiscount from '../../containers/Member/discount/member-discount';
import GrantDiscount from '../../containers/Reservation/discount/grant-discount';
import LocationInfo from '../../containers/Reservation/fox-reservation/fox-modal/location-modal/location-info';
import RentalExtension from '../../containers/Reservation/rental-extension/rental-extension';
import { ModalType } from '../../shared/GlobalVar';
import CustomerReservationHistory from '../reservation/customer-reservation-history';
import InvoiceComponent from '../reservation/invoice-component';
import TransactionComponent from '../reservation/transaction-component';
import ModalWrapper from './modal-wrapper';
import ModernConfirmModal from './modern-confirm-modal';
import { getRentalExtendConfirmCloseModal } from './modern-modal-data';

function ModernModalEngine(props) {
    const { modalType, modalProps, modalBodyProps } = props;
    const [msgFromChild, setMsgFromChild] = useState(null);
    const [closeConfirmModalProps, setCloseConfirmModalProps] = useState(null);

    const onYesCloseConfirmModal = () => {
        setCloseConfirmModalProps(null);
        modalProps.closeModal(modalProps?.setData);
    }
    const onShowCloseConfirmModal = () => {
        if (modalType === ModalType.RENTAL_EXTEND_MODAL && !msgFromChild?.couldTakeAction) {
            modalProps.closeModal(modalProps?.setData);
            return false;
        }
        getRentalExtendConfirmCloseModal(setCloseConfirmModalProps, onYesCloseConfirmModal);
    }

    return (
        <ModalWrapper
            onCloseAction={modalType === ModalType.RENTAL_EXTEND_MODAL ? onShowCloseConfirmModal : null}
            {...modalProps}
        >
            {modalType === ModalType.MEMBER_DISCOUNT_MODAL ?
                <MemberDiscount
                    {...modalBodyProps}
                />
                : ""}
            {modalType === ModalType.GRANT_DISCOUNT_MODAL ?
                <GrantDiscount
                    {...modalBodyProps}
                />
                : ""}
            {modalType === ModalType.RENTAL_EXTEND_MODAL ?
                <RentalExtension
                    onCloseAction={onShowCloseConfirmModal}
                    setMsgFromChild={setMsgFromChild}
                    {...modalBodyProps}
                />
                : ""}
            {modalType === ModalType.LOCATION_QUICK_MODAL ?
                <LocationInfo
                    {...modalBodyProps}
                />
                : ""}
            {modalType === ModalType.INVOICE_INFO_MODAL ?
                <InvoiceComponent
                    {...modalBodyProps}
                />
                : ""}
            {modalType === ModalType.TRANSACTION_MODAL ?
                <TransactionComponent
                    {...modalBodyProps}
                />
                : ""}
            {modalType === ModalType.CUSTOMER_RESERVATION_HISTORY_MODAL ?
                <CustomerReservationHistory
                    {...modalBodyProps}
                />
                : ""}
            {closeConfirmModalProps &&
                <ModernConfirmModal {...closeConfirmModalProps} />}
        </ModalWrapper>
    )
}

export default ModernModalEngine